import React, { useEffect, useState } from 'react'
import { Loader } from './child/Loader'
import { getSettlementPaymentOptions, switcchSettlementPayment } from '../services/fetchConfig';

const SwitchManagementLayer = () => {
    const [loading, setLoading] = useState(false);
    const [active, setActive] = useState("");
    const [switchSuccess, setSwitchSuccess] = useState(false);
    const [switchFail, setSwitchFail] = useState(false);
    const [availableOptions, setAvailableOptions] = useState([])

    useEffect(() => {
        setLoading(true)
        getSettlementPaymentOptions().then(res => {
            console.log("res : ", res);
            let buttonData = res?.filter(item => item.type==="BUTTON_CONFIG")
            let [activeOne] = res?.filter(item => item.type==="ACTIVE_BUTTON")
            setActive(activeOne?.new)
            setAvailableOptions(buttonData)
            setLoading(false)
        }).catch(err => {
            console.log(err);
        })
    }, [])
    const switchSettlement = (mode) => {
        if (active !== mode) {
            setLoading(true)
            switcchSettlementPayment(mode).then(res=>{
                console.log("switching res : ",res);
                setSwitchSuccess(true)
                setLoading(false)
                setTimeout(()=>setSwitchSuccess(false),5000)
                setActive(mode)
            }).catch(err=>{
                console.log("switch err :",err);
                setSwitchFail(true)
                setLoading(false)
                setTimeout(()=>setSwitchFail(false),5000)
            })
        }
    }
    return (
        <>
            <Loader loading={loading} />
            <>
                <div className="card h-100 p-0 radius-12">
                    <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                        <div className="d-flex flex-column  gap-3 w-100">
                            <p>Settlement gateway</p> 
                            <div className="d-flex flex-row align-items-center gap-3 w-100">
                                {
                                    availableOptions.map((gateway) => (<button className={`btn text-sm btn-sm px-24 py-12 ${active === gateway?.mode ? "btn-primary" : "btn-light border"} radius-8 d-flex align-items-center gap-2`} disabled={!gateway.isActive} onClick={() => switchSettlement(gateway.mode)}>
                                        {gateway.buttonName?.toUpperCase()}
                                    </button>))
                                }
                            </div>
                            {
                                switchSuccess&&<div className="alert alert-success d-flex align-items-center" role="alert">
                                    <i className="bi bi-check-circle-fill me-2 mr-4"></i>
                                    <span className='ms-8'>Switched Successfully! Your action was completed.</span>
                                </div>
                            }
                            {
                                switchFail&&<div className="alert alert-success d-flex align-items-center" role="alert">
                                    <i className="bi bi-exclamation-triangle-fill me-2 mr-4"></i>
                                    <span className='ms-8'>Something Went Wrong on Switching! Your action was not completed.</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </>
        </>
    )
}

export default SwitchManagementLayer